export const dataToStackChartData = (column, metric = "active_devices") => (data) => {
  const tmp = data.reduce((acc, curr)=>{
      acc[curr[column]] = acc[curr[column]] ?? []
      acc[curr[column]].push([Date.parse(curr.date), curr[metric]])
      return acc;
    },{}
  )
  const res = Object.entries(tmp).map((elt)=>({
    "name": elt[0],
    "data": elt[1].sort((a,b)=>(a[0] - b[0]))
  }))
  return res
}
